
import Cell from 'vux/src/components/cell/index.vue'

import { InsurStore } from '../store'
import { store } from '@/observable/store'
import  UserInfoToast  from '@/components/toast/userInfo'
import { customer } from '@/utils/customer/index.js'

export default {
data() {
return {
customerUrl:''
}
},
components: {
Cell,
UserInfoToast
},
created () {

},
computed: {
templateFlag(){
return this.$route.query.templateFlag
},
insurance() {
return InsurStore.insurance
},
uid(){
return store.uid
},
money(){
return InsurStore.moneyStr
}
},
methods: {
custUrl() {
this.$emit("custUrlClick")
setTimeout(()=>{
customer.customerLink(this.templateFlag)
})
},
btnClick(){
if(this.uid != 0){
this.goPay()
}else{
this.$refs.userlogin.showoast()
}
},
goPay(){
this.$emit("btnClick")

},
loginCallback(){
this.$emit("loginCallback")
}
},
}

